import { useState } from 'react';
import type { ComposerDraft } from './ThreadComposer';

/** The draft handed to a thread's composer (an unsent acknowledgement, or an empty one that clears it); it lives in
 *  state only, so closing the composer drops it. */
export function useComposerSeed(setEntry: (entryId: string | null) => void) {
  const [seed, setSeed] = useState<{ entryId: string; draft: ComposerDraft } | null>(null);
  const open = (entryId: string | null) => {
    setSeed(null);
    setEntry(entryId);
  };
  return {
    acknowledge: (entryId: string, draft: ComposerDraft) => {
      setSeed({ entryId, draft });
      setEntry(entryId);
    },
    leave: () => open(null),
    navigate: (entryId: string) => open(entryId),
    /** o-e2e2 N6: the acknowledgement went out from the Agree rate dialog, so whatever the composer held is cleared. */
    clear: (entryId: string) => setSeed({ entryId, draft: { kind: 'reply', body: '' } }),
    consumed: () => setSeed(null),
    seedFor: (entryId: string): ComposerDraft | undefined => (seed?.entryId === entryId ? seed.draft : undefined),
  };
}
